import { render } from "./ArticleModal.vue?vue&type=template&id=0e038d1d&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=0e038d1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e038d1d"]])

export default __exports__